

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// markRoomNotificationsAsRead
// MARKROOMNOTIFICATIONSASREAD   
const MARKROOMNOTIFICATIONSASREAD= createAsyncThunk(
  "markRoomNotificationsAsRead/markRoomNotificationsAsRead",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const markRoomNotificationsAsReadSlice = createSlice({
  name: "markRoomNotificationsAsReadSlice",
  initialState: {
    markRoomNotificationsAsRead: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfmarkRoomNotificationsAsRead: (state) => {
        state.markRoomNotificationsAsRead.loading = false
        state.markRoomNotificationsAsRead.error = false
        state.markRoomNotificationsAsRead.data = []
        state.markRoomNotificationsAsRead.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MARKROOMNOTIFICATIONSASREAD.fulfilled, (state, action) => {
      state.markRoomNotificationsAsRead = {
        ...state.markRoomNotificationsAsRead,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MARKROOMNOTIFICATIONSASREAD.pending, (state, action) => {
      state.markRoomNotificationsAsRead = {
        ...state.markRoomNotificationsAsRead,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MARKROOMNOTIFICATIONSASREAD.rejected, (state, action) => {
      state.markRoomNotificationsAsRead = {
        ...state.markRoomNotificationsAsRead,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const markRoomNotificationsAsReadAction = {
    MARKROOMNOTIFICATIONSASREAD,
};

export { markRoomNotificationsAsReadAction };
export default markRoomNotificationsAsReadSlice.reducer;
export const {setInitialStateOfmarkRoomNotificationsAsRead} = markRoomNotificationsAsReadSlice.actions